import React from 'react';
import { IconProps } from '@/models/IconProps';

const Plus: React.FC<IconProps> = ({ height = '24', width = '24', strokeColor = 'currentColor' }) => {
  return (
    <svg width={width} height={height} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        d="M12.75 5.00018C12.75 4.58597 12.4142 4.25018 12 4.25018C11.5858 4.25018 11.25 4.58597 11.25 5.00018V11.2502H5C4.58579 11.2502 4.25 11.586 4.25 12.0002C4.25 12.4144 4.58579 12.7502 5 12.7502H11.25V19.0002C11.25 19.4144 11.5858 19.7502 12 19.7502C12.4142 19.7502 12.75 19.4144 12.75 19.0002V12.7502H19C19.4142 12.7502 19.75 12.4144 19.75 12.0002C19.75 11.586 19.4142 11.2502 19 11.2502H12.75V5.00018Z"
        fill={strokeColor}
      />
    </svg>
  );
};

export default Plus;
